import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EmojiHappyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M23 12c0 6.08-4.92 11-11 11S1 18.08 1 12 5.92 1 12 1s11 4.92 11 11zM3 12a9 9 0 1018.001-.001A9 9 0 003 12z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M12 19c-4.64 0-6.37-4.46-6.44-4.65-.11-.31-.07-.65.11-.92.19-.27.49-.43.82-.43h10.5c.31 0 .6.14.79.38.19.24.26.56.18.86-.41 1.65-2.19 4.76-5.97 4.76H12zm-3.78-4c.7.93 1.92 2 3.78 2 1.86 0 2.92-1.08 3.48-2H8.22zM10 11c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1-1-.45-1-1c0-1.65 1.35-3 3-3s3 1.35 3 3c0 .55-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1-.45 1-1 1-1-.45-1-1c0-1.65 1.35-3 3-3s3 1.35 3 3c0 .55-.45 1-1 1z"
                        })
                    ]
                })
            })
        ]
    });
};
EmojiHappyIcon.isCarinaIcon = true;
export default EmojiHappyIcon;
